import { IonCard, IonCardContent, IonIcon } from '@ionic/react';
import { location, people, star, mail, call, logoWhatsapp } from 'ionicons/icons';
import BoringAvatar from '@/components/BoringAvatar';

interface AgentCardProps {
  agent: {
    id: string;
    slug?: string;
    displayName: string;
    bio?: string;
    area?: { label: string }[];
    contactEmail?: string;
    contactPhone?: string;
    whatsapp?: string;
    assignedCandidates?: number;
    assignedEmployers?: number;
    npsScore?: number;
  };
}

export function AgentCard({ agent }: AgentCardProps) {
  const detailPath = agent.slug ? `/agents/${agent.slug}` : `/agents/${agent.id}`;

  return (
    <IonCard className="bp-agent-card" routerLink={detailPath} button>
      <IonCardContent>
        <div className="bp-agent-card-layout">
          {/* Avatar */}
          <div className="bp-agent-avatar">
            <BoringAvatar name={agent.displayName} size={72} />
          </div>

          {/* Main content */}
          <div className="bp-agent-content">
            <h3 className="bp-agent-name">{agent.displayName}</h3>
            
            {agent.bio && (
              <p className="bp-agent-bio">{agent.bio}</p>
            )}

            {/* Location and stats */}
            <div className="bp-agent-meta">
              {agent.area?.[0] && (
                <span className="bp-agent-location">
                  <IonIcon icon={location} />
                  {agent.area[0].label}
                </span>
              )}
              
              <div className="bp-agent-stats">
                {typeof agent.assignedCandidates === 'number' && agent.assignedCandidates > 0 && (
                  <span className="bp-agent-stat">
                    <IonIcon icon={people} /> {agent.assignedCandidates}
                  </span>
                )}
                {typeof agent.assignedEmployers === 'number' && agent.assignedEmployers > 0 && (
                  <span className="bp-agent-stat">
                    <IonIcon icon={people} /> {agent.assignedEmployers} employers
                  </span>
                )}
                {typeof agent.npsScore === 'number' && (
                  <span className="bp-agent-stat bp-agent-nps">
                    <IonIcon icon={star} /> {agent.npsScore}/10
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Contact info */}
          <div className="bp-agent-contact">
            {agent.contactEmail && (
              <a href={`mailto:${agent.contactEmail}`} className="bp-agent-contact-item" onClick={(e) => e.stopPropagation()}>
                <IonIcon icon={mail} />
                <span>{agent.contactEmail}</span>
              </a>
            )}
            {agent.contactPhone && (
              <a href={`tel:${agent.contactPhone}`} className="bp-agent-contact-item" onClick={(e) => e.stopPropagation()}>
                <IonIcon icon={call} />
                <span>{agent.contactPhone}</span>
              </a>
            )}
            {agent.whatsapp && (
              <a href={`https://wa.me/${agent.whatsapp.replace(/\+/g, '')}`} className="bp-agent-contact-item" onClick={(e) => e.stopPropagation()}>
                <IonIcon icon={logoWhatsapp} />
                <span>{agent.whatsapp}</span>
              </a>
            )}
          </div>
        </div>
      </IonCardContent>
    </IonCard>
  );
}
